import { render, staticRenderFns } from "./DeliverPrintDetail.vue?vue&type=template&id=06f3e9a9"
import script from "./DeliverPrintDetail.vue?vue&type=script&lang=js"
export * from "./DeliverPrintDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports